// extracted by mini-css-extract-plugin
module.exports = {"root":"CheckoutPage_root__DD87j","submitButton":"CheckoutPage_submitButton__W2jcg","grid":"CheckoutPage_grid__29ZB3","tabs":"CheckoutPage_tabs__Xlpvm"};